// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:38:26

export default {
  "id": "100-doors-puzzle-box",
  "slug": "100-doors-puzzle-box",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/63a0e0f6011e442284345f364db53d81-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/63a0e0f6011e442284345f364db53d81/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "100 Doors Puzzle Box",
      "description": "The main goal in 100 Doors Puzzle Box is to escape the room. Using all the possibilities you need to open each of 100 doors and move the elevator to the next floor. Search for hidden objects, sovle puzzles and use an items to do this!",
      "instructions": "Use all your skills to complete all levels and get all achievements.\n\nControl for PC: Use the left and right mouse buttons,\nMobile devices: touch input",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "logic",
        "roomescape"
      ]
    },
    "zh-CN": {
      "title": "100道谜题盒子",
      "description": "在《100道门谜题盒》游戏中的主要目标是逃离房间。利用所有可能性，你需要打开100道门并移动电梯到下一层。寻找隐藏的物品，解决谜题并使用物品来完成这些任务！",
      "instructions": "使用你所有的技能完成所有关卡并获取所有成就。\n\nPC控制：使用鼠标左右键，\n移动设备：触摸输入",
      "genres": [
        "谜题"
      ],
      "tags": [
        "逻辑",
        "逃脱房间"
      ]
    },
    "zh-TW": {
      "title": "100道門謎盒",
      "description": "在100門解謎盒子的主要目標是逃離房間。利用所有可能的選擇，打開每一扇門，並將電梯移到下一層。尋找隱藏的物體，解謎並使用物品來完成這一切！",
      "instructions": "運用你所有的技能完成所有關卡並獲得所有成就。\n\n控制方式（PC版）：使用左鍵和右鍵，\n行動裝置：觸控輸入",
      "genres": [
        "謎題"
      ],
      "tags": [
        "邏輯",
        "密室逃脱"
      ]
    },
    "zh-HK": {
      "title": "百門謎題箱",
      "description": "100門謎題箱的主要目標是逃離房間。利用所有可能性打開每扇門，並將電梯移至下一層。尋找隱藏的物品，解謎並使用物品來完成這些任務！",
      "instructions": "盡用你所有技能完成所有關卡並取得所有成就。\n\nPC控制：使用左右鍵盤鍵，\n行動裝置：觸控輸入",
      "genres": [
        "謎題"
      ],
      "tags": [
        "邏輯",
        "密室逃脫"
      ]
    },
    "ja": {
      "title": "100の扉パズルボックス",
      "description": "100 Doors パズルボックスの主な目的は部屋から脱出することです。全ての可能性を使って100のドアを開き、エレベーターを次の階に移動させます。隠されたオブジェクトを探し、パズルを解き、アイテムを使ってこれを行います！",
      "instructions": "すべてのスキルを使ってレベルを全てクリアし、すべてのアチーブメントを獲得する。\n\nPC向けコントロール：左右のマウスボタンを使用，\nモバイル機器：タッチ入力",
      "genres": [
        "パズル"
      ],
      "tags": [
        "ロジック",
        "ルームイースカープ"
      ]
    },
    "ko": {
      "title": "100 문 문제 상자",
      "description": "100도어 퍼즐 박스의 주요 목표는 방을 탈출하는 것입니다. 모든 가능성을 사용하여 100개의 문을 열고 엘리베이터를 다음 층으로 이동시켜야 합니다. 숨겨진 물건을 찾고 퍼즐을 해결하고 이를 위해 아이템을 사용하세요!",
      "instructions": "모든 기술을 사용하여 모든 레벨을 완료하고 모든 달성물을 획득하세요.\n\nPC 제어법: 왼쪽과 오른쪽 마우스 버튼 사용,\n모바일 기기: 터치 입력",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "로직",
        "룸에스케이프"
      ]
    },
    "fr": {
      "title": "100 portes Puzzle Box",
      "description": "Le but principal dans 100 Doors Puzzle Box est de s'échapper de la pièce. Utilisez toutes les possibilités pour ouvrir chacune des 100 portes et faire monter l'ascenseur au prochain étage. Cherchez des objets cachés, résolvez des énigmes et utilisez des items pour cela !",
      "instructions": "Utilisez toutes vos compétences pour terminer tous les niveaux et obtenir toutes les récompenses.\n\nContrôle sur PC : Utilisez les boutons gauche et droit de la souris,\nAppareils mobiles : entrée tactile",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "logique",
        "évasion de pièce"
      ]
    }
  }
};
